"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _reactCheckboxTree = _interopRequireDefault(require("react-checkbox-tree"));
require("react-checkbox-tree/src/scss/react-checkbox-tree.scss");
var _useQuery3 = _interopRequireDefault(require("../useQuery.js"));
var _getGroups = _interopRequireDefault(require("../getGroups.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
var _fakeData = require("./fakeData.js");
var _without2 = _interopRequireDefault(require("lodash/without"));
var _flattenDeep2 = _interopRequireDefault(require("lodash/flattenDeep"));
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _users = _interopRequireDefault(require("cccisd-icons/users4"));
var _clock = _interopRequireDefault(require("cccisd-icons/clock"));
var _user = _interopRequireDefault(require("cccisd-icons/user"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _checkboxChecked = _interopRequireDefault(require("cccisd-icons/checkbox-checked2"));
var _checkboxUnchecked = _interopRequireDefault(require("cccisd-icons/checkbox-unchecked2"));
var _checkboxPartial = _interopRequireDefault(require("cccisd-icons/checkbox-partial2"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
var _folder = _interopRequireDefault(require("cccisd-icons/folder2"));
var _folderOpen = _interopRequireDefault(require("cccisd-icons/folder-open"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // Lodash
// Icons
var SelectGroups = function SelectGroups(props) {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    seeCompletedGroups = _useState2[0],
    setSeeCompletedGroups = _useState2[1];

  // console.log(props);
  var userType = props.userType;
  var ongoingGroups = [];
  var completedGroups = [];
  var _useQuery = (0, _useQuery3["default"])({
      query: _getGroups["default"],
      variables: props.filters
    }),
    _useQuery2 = _slicedToArray(_useQuery, 2),
    queryData = _useQuery2[0],
    loading = _useQuery2[1];

  // console.log({ queryData });

  var convertDataStructure = function convertDataStructure(myData) {
    // console.log(myData);
    var convertedData = [];
    if (loading === false) {
      convertedData = myData.groups.siteList.map(function (site) {
        if (site.group.groupId) {
          return {
            id: site.group.groupId,
            name: site.group.label,
            groups: site.childGroups.treatmentGroupList.map(function (group) {
              if (site.childGroups.treatmentGroupList.length > 0) {
                return {
                  id: group.group.groupId,
                  name: group.group.label,
                  numStudents: group.childRoles.participantCount,
                  currentSession: group.childRoles.metricspawn.assignmentProgressSummary.lastSessionHeld,
                  complete: group.childRoles.metricspawn.assignmentProgressList.length > 0 ? group.childRoles.metricspawn.assignmentProgressList.length === 5 && (0, _every2["default"])(group.childRoles.metricspawn.assignmentProgressList.map(function (x) {
                    return x.completed;
                  })) && group.childRoles.metricspawn.assignmentProgressSummary.lastSessionHeld === 'Session 5' : false,
                  archived: group.group.archived
                };
              }
              return null;
            })
          };
        }
        return null;
      });
    } else {
      convertedData = _fakeData.providerData;
    }
    // console.log({ convertedData });
    return convertedData;
  };
  var convertDataForIndividuals = function convertDataForIndividuals(myData) {
    var convertedData = [];
    if (loading === false) {
      // console.log(myData);
      convertedData = myData.groups.siteList.map(function (site) {
        if (site.group.groupId) {
          return {
            id: site.group.groupId,
            name: site.group.label,
            providers: site.childGroups.treatmentGroupList.map(function (group) {
              if (site.childGroups.treatmentGroupList.length > 0) {
                return {
                  id: group.group.groupId,
                  name: group.group.label,
                  numStudents: group.childRoles.participantCount,
                  currentSession: group.childRoles.metricspawn.assignmentProgressSummary.lastSessionHeld,
                  complete: group.childRoles.metricspawn.assignmentProgressList.length > 0 ? group.childRoles.metricspawn.assignmentProgressList.length === 5 && (0, _every2["default"])(group.childRoles.metricspawn.assignmentProgressList.map(function (x) {
                    return x.completed;
                  })) && group.childRoles.metricspawn.assignmentProgressSummary.lastSessionHeld === 'Session 5' : false,
                  archived: group.group.archived,
                  groups: group.childRoles.participantList.map(function (participant) {
                    return {
                      id: participant.pawn.pawnId,
                      name: participant.fields.participantId
                    };
                  })
                };
              }
              return null;
            })
          };
        }
        return null;
      });
    } else {
      convertedData = _fakeData.siteProviderData;
    }
    // console.log({ convertedData });
    return convertedData;
  };

  // Parse data for tree nodes
  var _getUserData = function _getUserData() {
    var data;
    if (props.userType === 'provider') {
      data = _fakeData.groupData;
      if (!seeCompletedGroups) {
        data = data.filter(function (group) {
          return group.complete !== true;
        });
      }
      ongoingGroups = data.filter(function (group) {
        return group.complete !== true;
      });
      completedGroups = data.filter(function (group) {
        return group.complete === true;
      });
      return data;
    }
    if (props.userType === 'siteAdmin') {
      // console.log(convertDataStructure(queryData));
      data = convertDataStructure(queryData).map(function (provider) {
        var completedGroupsPerProvider = provider.groups.filter(function (group) {
          return group.complete === true;
        });
        completedGroups = (0, _uniq2["default"])((0, _concat2["default"])(completedGroups, completedGroupsPerProvider.map(function (g) {
          return g.id;
        })));
        ongoingGroups = (0, _uniq2["default"])((0, _concat2["default"])(ongoingGroups, provider.groups.filter(function (group) {
          return group.complete !== true;
        }).map(function (g) {
          return g.id;
        })));
        var groupsFiltered = provider.groups;
        if (!seeCompletedGroups) {
          groupsFiltered = groupsFiltered.filter(function (group) {
            return group.complete !== true;
          });
        }
        return _objectSpread(_objectSpread({}, provider), {}, {
          groups: groupsFiltered
        });
      });
      return data;
    }
    if (props.userType === 'individuals') {
      data = convertDataForIndividuals(queryData).map(function (site) {
        // console.log(site);
        return _objectSpread(_objectSpread({}, site), {}, {
          providers: site.providers.map(function (provider) {
            var completedGroupsPerProvider = provider.groups.filter(function (group) {
              return group.complete === true;
            });
            completedGroups = (0, _uniq2["default"])((0, _concat2["default"])(completedGroups, completedGroupsPerProvider.map(function (g) {
              return g.id;
            })));
            ongoingGroups = (0, _uniq2["default"])((0, _concat2["default"])(ongoingGroups, provider.groups.filter(function (group) {
              return group.complete !== true;
            }).map(function (g) {
              return g.id;
            })));
            var groupsFiltered = provider.groups;
            if (!seeCompletedGroups) {
              groupsFiltered = groupsFiltered.filter(function (group) {
                return group.complete !== true;
              });
            }
            return _objectSpread(_objectSpread({}, provider), {}, {
              groups: groupsFiltered
            });
          })
        });
      });
      return data;
    }
    data = _fakeData.siteProviderData.map(function (site) {
      return _objectSpread(_objectSpread({}, site), {}, {
        providers: site.providers.map(function (provider) {
          var completedGroupsPerProvider = provider.groups.filter(function (group) {
            return group.complete === true;
          });
          completedGroups = (0, _uniq2["default"])((0, _concat2["default"])(completedGroups, completedGroupsPerProvider.map(function (g) {
            return g.id;
          })));
          ongoingGroups = (0, _uniq2["default"])((0, _concat2["default"])(ongoingGroups, provider.groups.filter(function (group) {
            return group.complete !== true;
          }).map(function (g) {
            return g.id;
          })));
          var groupsFiltered = provider.groups;
          if (!seeCompletedGroups) {
            groupsFiltered = groupsFiltered.filter(function (group) {
              return group.complete !== true;
            });
          }
          return _objectSpread(_objectSpread({}, provider), {}, {
            groups: groupsFiltered
          });
        })
      });
    });
    // console.log(data);
    return data;
  };
  var _getUserIds = function _getUserIds() {
    var data = _getUserData();
    if (props.userType === 'provider') {
      return (0, _flattenDeep2["default"])(data.map(function (d) {
        return d.id;
      }));
    }
    if (props.userType === 'siteAdmin') {
      return (0, _flattenDeep2["default"])([].concat(_toConsumableArray(data.map(function (d) {
        return d.id + 'p';
      })), _toConsumableArray(data.map(function (provider) {
        return provider.groups.map(function (group) {
          return group.id;
        });
      }))));
    }
    if (props.userType === 'individuals') {
      return (0, _flattenDeep2["default"])(data.map(function (site) {
        return [site.id + 's'].concat(_toConsumableArray(site.providers.map(function (p) {
          return [p.id + 'p'].concat(_toConsumableArray(p.groups.map(function (g) {
            return g.id;
          })));
        })));
      }));
    }
    return (0, _flattenDeep2["default"])(data.map(function (site) {
      return [site.id].concat(_toConsumableArray(site.providers.map(function (p) {
        return [p.id].concat(_toConsumableArray(p.groups.map(function (g) {
          return g.id;
        })));
      })));
    }));
  };
  var _useState3 = (0, _react.useState)(_getUserIds()),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  (0, _react.useEffect)(function () {
    setExpanded(_getUserIds());
  }, [loading]);

  // console.log(expanded);

  var _renderIndividualNode = function _renderIndividualNode(individual) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].leaf
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupName
    }, individual.name));
  };
  var _renderGroupNode = function _renderGroupNode(group) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].leaf
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupName
    }, group.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupInfo
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].numStudents
    }, /*#__PURE__*/_react["default"].createElement(_users["default"], {
      spaceRight: true
    }), group.numStudents, " Participants"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sessionStatus
    }, group.complete ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
      spaceRight: true
    }), "Complete") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, group.currentSession ? "".concat(group.currentSession) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: '#c63a1a'
      }
    }, group.archived && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Archived"))));
  };
  var _renderProviderNode = function _renderProviderNode(provider) {
    var numCompletedGroups = provider.groups.filter(function (group) {
      return group.complete === true;
    }).length;
    var numOngoingGroups = provider.groups.filter(function (group) {
      return group.complete !== true;
    }).filter(function (g) {
      return g.archived !== true;
    }).length;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].leaf
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupName
    }, provider.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupInfo
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].numStudents
    }, /*#__PURE__*/_react["default"].createElement(_clock["default"], {
      spaceRight: true
    }), numOngoingGroups, " Ongoing Groups"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sessionStatus
    }, numCompletedGroups > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
      spaceRight: true
    }), numCompletedGroups, " Completed Groups"))));
  };
  var _renderSiteNode2 = function _renderSiteNode2(site) {
    var numCompletedGroups = site.providers.filter(function (group) {
      return group.complete === true;
    }).length;
    var numOngoingGroups = site.providers.filter(function (group) {
      return group.complete !== true;
    }).filter(function (g) {
      return g.archived !== true;
    }).length;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].leaf
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupName
    }, site.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupInfo
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].numStudents
    }, /*#__PURE__*/_react["default"].createElement(_clock["default"], {
      spaceRight: true
    }), numOngoingGroups, " Ongoing Groups"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sessionStatus
    }, numCompletedGroups > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
      spaceRight: true
    }), numCompletedGroups, " Completed Groups"))));
  };
  var _renderSiteNode = function _renderSiteNode(site) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].leaf
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupName
    }, site.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].groupInfo
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].numStudents
    }, /*#__PURE__*/_react["default"].createElement(_user["default"], {
      spaceRight: true
    }), site.providers.length, " Provider(s)")));
  };
  var _getNodes = function _getNodes() {
    var nodes;
    if (props.userType === 'provider') {
      nodes = _getUserData().map(function (group) {
        return {
          value: group.id,
          label: _renderGroupNode(group),
          className: _style["default"].node
        };
      });
      return nodes;
    }
    if (props.userType === 'siteAdmin') {
      nodes = _getUserData().map(function (provider) {
        return {
          value: provider.id + 'p',
          label: _renderProviderNode(provider),
          className: _style["default"].node,
          showCheckbox: props.reportHandle !== 'outcomes',
          children: provider.groups.map(function (group) {
            return {
              value: group.id,
              label: _renderGroupNode(group),
              disabled: props.reportHandle === 'outcomes' && props.field.value.length > 0 && !props.field.value.includes(group.id),
              className: _style["default"].node
            };
          })
        };
      });
      return nodes;
    }
    if (props.userType === 'individuals') {
      // console.log('userData', _getUserData());
      nodes = _getUserData().map(function (site) {
        return {
          value: site.id + 's',
          label: _renderSiteNode2(site),
          showCheckbox: props.reportHandle !== 'outcomes',
          // className: style.node,
          children: site.providers.map(function (provider) {
            return {
              value: provider.id + 'p',
              label: _renderGroupNode(provider),
              showCheckbox: props.reportHandle !== 'outcomes',
              // className: style.node,
              children: provider.groups.map(function (group) {
                return {
                  value: group.id,
                  label: _renderIndividualNode(group),
                  disabled: props.reportHandle === 'outcomes' && props.field.value.length > 0 && !props.field.value.includes(group.id),
                  className: _style["default"].node
                };
              })
            };
          })
        };
      });
      return nodes;
    }
    nodes = _getUserData().map(function (site) {
      return {
        value: site.id,
        label: _renderSiteNode(site),
        className: _style["default"].node,
        children: site.providers.map(function (provider) {
          return {
            value: provider.id,
            label: _renderProviderNode(provider),
            className: _style["default"].node,
            children: provider.groups.map(function (group) {
              return {
                value: group.id,
                label: _renderGroupNode(group),
                className: _style["default"].node
              };
            })
          };
        })
      };
    });
    return nodes;
  };
  var _setCheckAll = function _setCheckAll() {
    var filteredIds = _getUserIds().filter(function (x) {
      return typeof x === 'number';
    });
    props.form.setFieldValue('groupIds', filteredIds);
  };
  var _setUncheckAll = function _setUncheckAll() {
    props.form.setFieldValue('groupIds', []);
  };
  var handleOnCheck = function handleOnCheck(selectedGroups) {
    var groupIdNumbers = selectedGroups.map(function (id) {
      return Number(id);
    });
    props.form.setFieldValue('groupIds', groupIdNumbers);
  };
  var handleSeeCompletedGroups = function handleSeeCompletedGroups() {
    setSeeCompletedGroups(!seeCompletedGroups);
    props.form.setFieldValue('groupIds', _without2["default"].apply(void 0, [props.field.value].concat(_toConsumableArray(completedGroups.map(function (group) {
      return group.name;
    })))));
  };

  // console.log(props);

  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: userType === 'individuals' ? 'Select Participant' : 'Select Groups',
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-success",
      onClick: function onClick() {}
    }, /*#__PURE__*/_react["default"].createElement(_users["default"], {
      spaceRight: true
    }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Select ", userType === 'individuals' ? 'Participant' : 'Groups')),
    size: "large",
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement("div", null, userType !== 'individuals' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].modalFilters
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].groupStatus
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].highlightValue
      }, ongoingGroups.length), " Ongoing Groups"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].highlightValue
      }, completedGroups.length), " Completed Groups")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].checkboxes
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        name: "select-all",
        value: "select-all",
        checked: seeCompletedGroups,
        onChange: handleSeeCompletedGroups
      }), ' ', "See data for completed groups")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttons,
        style: {
          marginBottom: '1em'
        }
      }, props.reportHandle !== 'outcomes' && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: function onClick() {
          return _setCheckAll();
        }
      }, "Check All"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: function onClick() {
          return _setUncheckAll();
        }
      }, "Uncheck All")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].checkboxTree
      }, /*#__PURE__*/_react["default"].createElement(_reactCheckboxTree["default"], {
        nodes: _getNodes(),
        checked: props.field.value,
        expanded: expanded,
        onCheck: function onCheck(checked) {
          return handleOnCheck(checked);
        },
        onExpand: function onExpand(expandedNodes) {
          return setExpanded(expandedNodes);
        },
        icons: {
          check: /*#__PURE__*/_react["default"].createElement(_checkboxChecked["default"], null),
          uncheck: /*#__PURE__*/_react["default"].createElement(_checkboxUnchecked["default"], null),
          halfCheck: /*#__PURE__*/_react["default"].createElement(_checkboxPartial["default"], null),
          expandClose: /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null),
          expandOpen: /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null),
          expandAll: /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null),
          collapseAll: /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null),
          parentClose: props.reportHandle !== 'outcomes' ? /*#__PURE__*/_react["default"].createElement(_folder["default"], null) : null,
          parentOpen: props.reportHandle !== 'outcomes' ? /*#__PURE__*/_react["default"].createElement(_folderOpen["default"], null) : null,
          leaf: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttons
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: closeModal
      }, "Close")));
    }
  });
};
SelectGroups.propTypes = {
  data: _propTypes["default"].array,
  userType: _propTypes["default"].string,
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  filters: _propTypes["default"].object,
  reportHandle: _propTypes["default"].string
};
SelectGroups.defaultProps = {
  userType: 'siteAdmin'
};
var _default = exports["default"] = SelectGroups;